import Modal from "../../common/Modal";
import TargetHistoryTable from "./TargetHistoryTable";
import TargetFileUpload from "./TargetFileUpload";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { CommonActions } from "../../../store/action";
import Select from "react-select";
import CustomValueContainer from "../../common/CustomValueContainer";

function AddTargetData(props) {
    const { t } = useTranslation("common");
    const dispatch = useDispatch();

    let {sampleFile, bulkUploadPopUp} = props;
    const fileUploadType = 4;
 
    const rolesList = useSelector(state => state?.common?.getRoleList);

    const [selectedRoleId, setSelectedRoleId] = useState(0);

    useEffect(() => {
        if (!rolesList) {
            dispatch(CommonActions.getRoleList());
        }
    }, [dispatch, rolesList]);
   
    return ( 
        <> 
            <div className={"model-popup-outer bulk-upload-history-popup"}>
                <Modal show={bulkUploadPopUp} handleClose={()=>props.handleClose()} >
            
                    <div className="modal-body">
                    <div className='bulk-upload-history-content p-md-t'>
                                <div className='bulk-upload-sec'>
                                    <div className="add-target-data-heading">
                                        <h3>Target Upload</h3>
                                        <fieldset className="single-select">
                                            <div className="material">
                                                <Select
                                                    components={{ ValueContainer: CustomValueContainer }}
                                                    value={rolesList?.filter(({ sfa_role_id }) => sfa_role_id === selectedRoleId)}
                                                    onChange={(option) => setSelectedRoleId(option.sfa_role_id)}
                                                    options={rolesList?.filter(role => role.if_status === 1)}
                                                    placeholder={`${t('FORM.USER_ROLE')}*`}
                                                    className="react-select"
                                                    classNamePrefix="react-select"
                                                    isSearchable={false}
                                                />
                                            </div>
                                        </fieldset>
                                    </div>
                                    <TargetFileUpload month={props.month} fileUploadType={fileUploadType} disabled={!selectedRoleId} role_id={selectedRoleId} />

                                </div>
                                <TargetHistoryTable fileUploadType={fileUploadType} />
                            </div> 
                        
                    </div>
                    <div className="modal-footer">
                        <div className="download-txt">
                            Download input format < a href={sampleFile}>
                                Click Here
                            </a>
                        </div>
                    </div>
                </Modal>
            </div> 
        </> 
  );
}

export default AddTargetData;